import _taggedTemplateLiteral from "/root/code/node_modules/next/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  transform: translateY(-50%);\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from "react";
import { Flex, Text, LinkButton, styled, Link } from "@catchoftheday/cg-components";
import { ClubCatchHeader } from "../../../components/ClubCatchHeader";
import { jsx as ___EmotionJSX } from "@emotion/react";
var CTAButton = styled(LinkButton)(_templateObject());
export var SimplePopupContent = function SimplePopupContent() {
  return ___EmotionJSX(Flex, {
    width: "400px",
    flexDirection: "column",
    color: "typography.text",
    boxShadow: "0 2px 4px 0 rgba(0,0,0,0.50)",
    bg: "white"
  }, ___EmotionJSX(ClubCatchHeader, null, ___EmotionJSX(Text, {
    textStyle: "h3",
    m: "0",
    textAlign: "center"
  }, "Deals, meet points"), ___EmotionJSX(Text, {
    m: "0",
    textAlign: "center"
  }, "Collect 2 flybuys points per $1 spent with Catch", ___EmotionJSX("sup", null, "*"))), ___EmotionJSX(Flex, {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  }, ___EmotionJSX(CTAButton, {
    block: false,
    mr: "0.875rem",
    sizeVariant: "sm",
    variant: "primary",
    textTransform: "none",
    href: "/rewards/flybuys/link",
    "data-tracking": "header-app-club-catch-link-flybuys"
  }, "LINK flybuys"), ___EmotionJSX(Flex, {
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "wrap",
    width: "100%",
    p: "0px 15px 5px"
  }, ___EmotionJSX(Link, {
    href: "/flybuys-catch",
    "data-tracking": "header-app-flybuys-learn-more"
  }, "Learn More")), ___EmotionJSX(Text, {
    textStyle: "small",
    p: "5px 15px 15px 15px"
  }, ___EmotionJSX("sup", null, "*"), " Terms, conditions and exclusions apply")));
};
export default SimplePopupContent;